
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/data-protection",
      function () {
        return require("private-next-pages/legal/data-protection/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/data-protection"])
      });
    }
  